import $ from 'jquery';
import 'slick-carousel';
import './jquery.twentytwenty';
import { hotspots } from './featuredProduct';
import { videoPlayer } from './videoPlayer';
import { verticalTabs } from './verticalTabs';
import { productDetailsTabs } from './productDetailsTabs';
import { navigation } from './navigation';
import { accordion } from './accordion';
import { imageGallery } from './imageGallery';
import { loadMore } from './loadMore';
import { teamArchive } from './teamArchive';
import { productHero } from './productHero';
import { relatedPosts } from './relatedPosts';
import { imageSlider } from './imageSlider';
import { embedPlayer } from './embedPlayer';
import { videoArchive } from './videoArchive';
import { productGrid } from './productGrid';
import { stats } from './stats';
import { documentTabs } from './documentTabs';
import { cookieBanner } from './cookieBanner';

hotspots();

videoPlayer();

verticalTabs();

productDetailsTabs();

navigation();

accordion();

imageGallery();

loadMore();

teamArchive();

productHero();

relatedPosts();

imageSlider();

videoArchive();

embedPlayer();

productGrid();

stats();

documentTabs();

cookieBanner();

$('.testimonial__quote-section').slick({
  dots: true,
  arrows: false,
  adaptiveHeight: true
});